import React from 'react';
import { Modal } from 'react-bootstrap';

const GeneratingModal = (props) => (
  <Modal
    {...props}
    size="lg"
    backdrop="static"
    centered
  >
    <Modal.Body>
      PDF genereren. Even geduld alstublieft.
    </Modal.Body>
  </Modal>
);

export default GeneratingModal;
